import { useMutation, useQueryClient } from '@tanstack/react-query';

import { UsersService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useDeleteUserMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (userId: string) => {
      return UsersService.usersServiceDeleteUser({
        path: { id: userId },
      });
    },
    onSettled: async (_data, _error, userId) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.users.list() }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.users.details(userId),
        }),
      ]);
    },
  });
};
